package com.example.readingnotes.data.remote.dto

import kotlinx.serialization.Serializable

@Serializable
data class LoginRequestDto(
    val password: String,
)

@Serializable
data class LoginResponseDto(
    val isAdmin: Boolean,
)

@Serializable
data class AuthStateResponseDto(
    val isAdmin: Boolean,
)

@Serializable
data class LogoutResponseDto(
    val ok: Boolean,
)

// Email authentication DTOs
@Serializable
data class SendVerificationCodeRequestDto(
    val email: String,
)

@Serializable
data class SendVerificationCodeResponseDto(
    val success: Boolean,
    val message: String,
)

@Serializable
data class VerifyEmailRequestDto(
    val email: String,
    val code: String,
)

@Serializable
data class LoginWithCodeRequestDto(
    val email: String,
    val code: String,
)

@Serializable
data class EmailAuthResponseDto(
    val user: UserAuthDto,
    val accessToken: String,
    val refreshToken: String,
)

@Serializable
data class UserAuthDto(
    val id: String,
    val username: String?,
    val email: String,
    val role: String,
    val emailVerifiedAt: String?,
    val totpEnabled: Boolean,
)
